import { theme } from "antd";
import { MappingAlgorithm } from "antd/lib";
import { ThemeConfig } from "antd/es/config-provider/context";
import { AliasToken, OverrideToken } from "antd/es/theme/interface";
import { defaultsDeep } from "lodash-es";

type ThemeType = "dark" | "light";

export const createCustomTheme = (client: ClientSettings) => {
  const byxTheme = client.theme;

  const TOKEN: Record<ThemeType, Partial<AliasToken>> = {
    dark: {},
    light: {
      colorBorder: "#8a92a6",
    },
  };

  const COMPONENTS: Record<ThemeType, OverrideToken> = {
    dark: {
      Layout: {
        headerBg: "#2e353c",
      },
    },
    light: {
      Layout: {
        headerBg: "transparent",
      },
      Table: {
        colorTextHeading: "#8a92a6",
      },
    },
  };

  const IS_DARK = false;

  const lightAlgorithm: MappingAlgorithm = (designToken) => {
    return {
      ...theme.defaultAlgorithm(designToken),
      colorBgLayout: "transparent",
    };
  };

  const defaultThemeConfig: ThemeConfig = {
    algorithm: lightAlgorithm,
    token: {
      colorInfo: byxTheme.token?.colorPrimary,
      controlHeight: 36,
      fontFamily: "PF Encore Sans Pro, sans-serif",
      ...(IS_DARK ? TOKEN.dark : TOKEN.light),
    },
    components: {
      ...(IS_DARK ? COMPONENTS.dark : COMPONENTS.light),
    },
  };

  const customTheme = defaultsDeep(defaultThemeConfig, byxTheme) as ThemeConfig;

  return customTheme;
};
